(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  const initHomeHeroCarousel = (carousel) => {
    if (carousel.dataset.homeHeroReady === 'true') return;

    const track = carousel.querySelector('[data-home-hero-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-home-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-home-hero-dot]'));
    let index = 0;
    let interval = null;

    if (!track || slides.length <= 1) return;

    const goTo = (nextIndex) => {
      index = nextIndex;
      track.style.transform = `translate3d(${-100 * index}%, 0, 0)`;

      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('home-hero-carousel__dot--active', dotIndex === index);
      });
    };

    const stop = () => {
      if (interval) {
        window.clearInterval(interval);
        interval = null;
      }
    };

    const start = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      const speed = Number.parseInt(getComputedStyle(carousel).getPropertyValue('--home-hero-cycle-speed'), 10) || 5000;
      interval = window.setInterval(() => goTo((index + 1) % slides.length), speed);
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        goTo(dotIndex);
        start();
      });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.dataset.homeHeroReady = 'true';
    start();
  };

  const initHomeHeroCarousels = (root = document) => {
    root.querySelectorAll('[data-home-hero-carousel]').forEach(initHomeHeroCarousel);
  };

  initHomeHeroCarousels();
  document.addEventListener('shopify:section:load', (event) => initHomeHeroCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
